<div *ngIf="!hidden" class="componentWrapper" id="{{component.id}}">
    <mat-form-field appearance="{{appearance}}" [ngClass]="{'stretchToFit': hasOptionValue(component, 'isFitScreen', true)}">
        <mat-label>{{label}}</mat-label>
        <input matInput [formControl]="formControl" [placeholder]="label" [required]="isRequired" [matDatepicker]="picker" [readonly]="readonly">
        <!-- TODO format date and option:disableCalendarInput -->
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="formControl.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
</div>
